import React, { Component } from "react";
import { Row, Col, Card, CardBody, Container } from "reactstrap";
import { Link } from "react-router-dom";

import { LinkPreview } from "@dhaiwat10/react-link-preview";

class UiCarousel extends Component {
  constructor(props) {
    super(props);
    console.log(this.props)
    this.state = {
      data: this.props.sources
    };
  }

  render() {
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>

            <Row>
              <Col xl={6}>
                <Card>
                  <CardBody>
                    <h4 className="card-title">Latest Source</h4>
                     <p className="card-title-desc">Here is latest source added here for the testimony.<br/>
                     <b>Description:</b> {this.state.data === undefined || this.state.data.length == 0 ? "" : this.state.data[this.state.data.length-1].description}
                     </p>
                     <LinkPreview
                        margin="30px auto"
                        width="500px"
                        url={this.state.data === undefined || this.state.data.length == 0 ? "https://www.utjd.org" : this.state.data[this.state.data.length-1].url}
                        fallbackImageSrc='https://www.utjd.org/register/wp-content/uploads/2020/01/67962678_100889521264732_4332210447777267712_n.png'
                      />
                  </CardBody>
                </Card>
              </Col>
              <Col xl={6}>
                <Card>
                  <CardBody>
                    <h4 className="card-title">List of all available sources</h4>
                     <p className="card-title-desc">Here is the list of all added source those available in the testimony section.</p>
                     {this.state.data.map((each, key) => 
                          <div>
                              <h5>{each.description}</h5>
                              <p>
                              <Link to={{ pathname: each.url }} target="_blank">Read more</Link>
                              </p>
                          </div>
                      )}
                  </CardBody>
                </Card>
              </Col>
            </Row>

          </Container>
        </div>
      </React.Fragment>
    );
  }
}

export default UiCarousel;
